import { Card } from '@blueprintjs/core';
import { ArrowRight } from '@carbon/icons-react';
import * as React from 'react';
import {
  Body,
  Icon,
  IconComponentType,
} from 'vet-bones/design-system/components';

import {
  PRODUCT_CARD_TEST_ID,
  PRODUCT_DESC_TEST_ID,
} from 'src/ui/constants/testIds';
import { copy } from 'src/ui/templates/copy';

interface OwnProps {
  description: string;
  icon: IconComponentType;
  label: string;
  onClick: () => void;
}

export const ProductCard: React.VFC<OwnProps> = ({
  description,
  icon,
  label,
  onClick,
}) => {
  const productName = label.split(' ').pop()?.toLowerCase();
  return (
    <Card
      className="product-card"
      data-testid={`${productName}-${PRODUCT_CARD_TEST_ID}`}
      interactive
      onClick={onClick}
      role="button"
    >
      <div className="product-card-header">
        <div className="product-card-icon">
          <Icon IconComponent={icon} size={28} />
        </div>
        <Body size="lg" weight="semibold">
          {label}
        </Body>
      </div>
      <Body
        className="product-card-description"
        size="md"
        testId={`${productName}-${PRODUCT_DESC_TEST_ID}`}
      >
        {description}
      </Body>
      <div className="product-card-action">
        <Body size="md" weight="semibold">
          {copy.dashboard.openAction}
        </Body>
        <Icon IconComponent={ArrowRight} size="sm" />
      </div>
    </Card>
  );
};
